import { type EChartsExtensionInstallRegisters } from 'echarts/lib/extension';
import type GlobalModel from 'echarts/lib/model/Global';
import type ExtensionAPI from 'echarts/lib/core/ExtensionAPI';
import CartesianAxisModel from 'echarts/lib/coord/cartesian/AxisModel';
import CartesianAxisView from 'echarts/lib/component/axis/CartesianAxisView';
import { Group } from 'echarts/lib/util/graphic';
import { Displayable } from 'zrender';
import { AxisElementTypeDispatcher } from './helper';
import { AxisElementType } from './types';

interface CartesianAxisIns {
  axisModel: CartesianAxisModel;
  axisView: CartesianAxisView;
}
type AxisGroup = Group;
const axisTypes = ['xAxis', 'yAxis'];

function doParseAxisElementsZ(axisIns: CartesianAxisIns) {
  const { axisModel, axisView } = axisIns;
  const axisGroup = axisView._axisGroup as AxisGroup;
  const dispatcher = new AxisElementTypeDispatcher();

  axisGroup.traverse(el => {
    if (!el.anid) {
      return;
    }

    const elType = dispatcher.getElementType(el.anid) as unknown as AxisElementType;
    const elDvZ = axisModel.get([elType, 'dvZ']);
    if (typeof elDvZ === 'undefined') {
      return;
    }

    (el as unknown as Displayable).attr({
      z: elDvZ as number
    });
  });
}

function parseAxisElementsZ(ecModel: GlobalModel, api: ExtensionAPI) {
  const axisInsArr = axisTypes.reduce((arr, type) => {
    const axisInses = ecModel.queryComponents({ mainType: type }).map(model => {
      return {
        axisModel: model as CartesianAxisModel,
        axisView: api.getViewOfComponentModel(model) as CartesianAxisView
      };
    });
    arr.push(...axisInses);
    return arr;
  }, [] as CartesianAxisIns[]);

  axisInsArr.forEach(axisIns => {
    doParseAxisElementsZ(axisIns);
  });
}

export function install(registers: EChartsExtensionInstallRegisters) {
  registers.registerUpdateLifecycle('afterupdate', (ecModel, api) => {
    parseAxisElementsZ(ecModel, api);
  });
}
